import type { ComponentType } from 'react';
import { BuildingsIcon } from '@phosphor-icons/react';

import type { OrgRowProps } from './OrganizationSwitcher';

export const ACCOUNT_LEVEL_LABEL = 'All divisions';

/** The switcher's entry for the account level, drawn as one of its rows
    (handed in as `Row`, since the row lives with the switcher). */
export function AccountLevelOption({
  Row,
  accountName,
  selected,
  onPress,
}: {
  Row: ComponentType<OrgRowProps>;
  accountName: string;
  selected: boolean;
  onPress: () => void;
}) {
  return (
    <Row
      icon={<BuildingsIcon size={12} />}
      label={ACCOUNT_LEVEL_LABEL}
      secondary={accountName}
      selected={selected}
      onPress={onPress}
    />
  );
}
